module.exports = __webpack_public_path__ + "static/media/002_naku.77f4f52b.gif";